import { Routes, Route } from "react-router-dom";
import Main from "./Main";
import Game from "./Game";
import PrivacyPolicy from "./Privacy";
import About from "./About";
// import Switcher from './Switcher.jsx';

function App() {
  if (window.location.pathname === "/savior" || window.location.pathname === "/savior/about") {
    document.title = "Savior - Daily"
    document.querySelector('meta[name="description"]')!.setAttribute('content', "The first four words are chosen for you. It's up to you to save the game!");
  }
  if (window.location.pathname === "/savior/practice" || window.location.pathname === "/savior/practice/about") {
    document.title = "Savior - Practice"
    document.querySelector('meta[name="description"]')!.setAttribute('content', "The first four words are chosen for you. It's up to you to save the game!");
  }
  
  

  return (
    <Routes>
      <Route path="/" element={<Main />} />
      <Route path="/sedec-order" element={<Game type="sedec-order" />} />
      <Route path="/sedec-order/practice" element={<Game type="sedec-order" />} />
      <Route path="/savior" element={<Game type="savior" />} />
      <Route path="/savior/practice" element={<Game type="savior" />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/about" element={<About />} />
      <Route path="/sedecordle/about" element={<About />} />
      <Route path="/sedecordle/practice/about" element={<About />} />
      <Route path="/sedec-order/about" element={<About />} />
      <Route path="/sedec-order/practice/about" element={<About />} />
      <Route path="/savior/about" element={<About />} />
      <Route path="/savior/practice/about" element={<About />} />
    </Routes>
  );
}

export default App;